import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Feed from '../../Feed';
import * as palette from '../../../components/General/Variables';
import { getLocalAppStateAsync } from '../../../services/api/db';
import TilesAndWidgets from '../components/TilesAndWidgets';
import { parseTileGroups } from '../service/parsing';

const Container = styled.div`
    padding: 24px;
    width: 100%;
    max-width: 100vw;
    display: flex;
    flex-direction: ${props => (props.isDesktop ? 'row' : 'column')};

    & > * {
        flex: 0 ${props => (props.hasNews && props.isDesktop ? '50%' : '100%')};
        max-width: ${props => (props.hasNews && props.isDesktop ? '50%' : '100%')};
        height: fit-content;
    }
`;

const LandingPage = props => {
    const [hasNews, setHasNews] = useState(true);
    const [tileGroups, setTileGroups] = useState([]);

    const isDesktop = window.innerWidth > palette.MIN_DESKTOP_INT;
    useEffect(() => {
        (async () => {
            const appState = await getLocalAppStateAsync();

            if (typeof appState.hasNews === 'boolean') {
                setHasNews(appState.hasNews);
            }

            if (appState.tileGroups) {
                setTileGroups(parseTileGroups(appState.tileGroups));
            }
        })();
    }, []);

    return (
        <Container hasNews={hasNews} isDesktop={isDesktop}>
            {tileGroups.length > 0 && (
                <TilesAndWidgets tileGroups={tileGroups} hasNews={hasNews} {...props} />
            )}
            {hasNews && <Feed {...props} />}
        </Container>
    );
};

export default LandingPage;
